module.exports = __webpack_public_path__ + "static/media/user1.56a1f25e.png";